import styled from 'styled-components';

export default styled.div`
  margin: 2rem 0;
`;
